import React, { Suspense, lazy } from 'react';
import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import './index.css';
// import reportWebVitals from './reportWebVitals';
import store from './store'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'

let persistor = persistStore(store);
import { Provider } from 'react-redux'

// import Home from './pages/home/Home';
// import Login from './pages/login/Login';
// import Register from './pages/register/Register';
// import NoMatch from './pages/nomatch/NoMatch';
// import Users from './pages/users/Users';
// import Product from './pages/product/Product';
// import Cart from './pages/cart/Cart';
// import Order from './pages/order/Order';
// import Orders from './pages/orders/Orders';
// import OrderDetail from './pages/orderDetail/OrderDetail';
// import Customer from './pages/customer/Customer';
// import Account from './pages/account/Account';
// import Contact from './pages/contact/Contact';
// import Bricoman from './pages/bricoman/Bricoman';
// import Privacy from './pages/privacy/Privacy';
// import Terms from './pages/terms/Terms';
// import Admin from './pages/admin/Admin';
// import Xero from './pages/xero/Xero';
// import InvoiceDetail from './pages/invoiceDetail/InvoiceDetail';
// import Payment from './pages/payment/Payment';
// import Invoices from './pages/invoices/Invoices';
// import CreditNotes from './pages/creditnotes/CreditNotes';
// import Reports from './pages/reports/Reports';
// import IkeaOrders from './pages/ikeaOrders/IkeaOrders';
// import CreditNoteDetail from './pages/CreditNoteDetail/CreditNoteDetail';
// import CreateCreditNote from './pages/createCreditNote/createCreditNote';
// import ResetPasswordPage from './pages/reset/Reset';

import Home from './pages/home/HomeV2';
import Login from './pages/login/LoginV2';
import Register from './pages/register/RegisterV2';
import NoMatch from './pages/nomatch/NoMatchV2';
import Users from './pages/users/UsersV2';
import Product from './pages/product/ProductV2';
import Cart from './pages/cart/CartV2';
import Order from './pages/order/OrderV2';
import Orders from './pages/orders/OrdersV2';
import OrderDetail from './pages/orderDetail/OrderDetailV2';
import Customer from './pages/customer/CustomerV2';
import Account from './pages/account/AccountV2';
import Contact from './pages/contact/ContactV2';
import Bricoman from './pages/bricoman/BricomanV2';
import Privacy from './pages/privacy/PrivacyV2';
import Terms from './pages/terms/TermsV2';
import Admin from './pages/admin/AdminV2';
import Xero from './pages/xero/XeroV2';
import InvoiceDetail from './pages/invoiceDetail/InvoiceDetailV2';
import Payment from './pages/payment/PaymentV2';
import Invoices from './pages/invoices/InvoicesV2';
import CreditNotes from './pages/creditnotes/CreditNotesV2';
import Reports from './pages/reports/ReportsV2';
import IkeaOrders from './pages/ikeaOrders/IkeaOrdersV2';
import CreditNoteDetail from './pages/CreditNoteDetail/CreditNoteDetailV2';
import CreateCreditNote from './pages/createCreditNote/createCreditNoteV2';
import ResetPasswordPage from './pages/reset/ResetV2';

import AdminRevenueV2 from './pages/admin/AdminRevenueV2';
import Packing from './pages/packing/Packing';

import { ToastContainer } from 'react-toastify';
import { PdfPrintPreviewHost } from './pdfPrinting';

const PdfPreviewPage = lazy(() => import('./pages/pdfPreview/PdfPreviewPage'));
import ScrollToTop from './utils/ScrollToTop';
import { Analytics } from '@vercel/analytics/react';
import { installIkeaImageFallback } from './utils/ikeaImage';

installIkeaImageFallback();

const rootElement = document.getElementById("root");
render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ToastContainer
       autoClose={500}
      />
      <PdfPrintPreviewHost />
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="login" element={<Login />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="register" element={<Register />} />
          <Route path="users" element={<Users />} />
          <Route path="orders" element={<Orders />} />
          <Route path="creditnotes" element={<CreditNotes />} />
          <Route path="reports" element={<Reports />} />
          <Route path="ikeaorders" element={<IkeaOrders />} />
          <Route path="packing" element={<Packing />} />
          <Route
            path="internal/pdf-preview"
            element={
              <Suspense fallback={<div style={{ padding: 48, fontFamily: 'system-ui' }}>Loading PDF tools…</div>}>
                <PdfPreviewPage />
              </Suspense>
            }
          />
          <Route path="invoices" element={<Invoices />} />
          <Route path="cart" element={<Cart />} />
          <Route path="order" element={<Order />} />
          <Route path="account" element={<Account />} />
          <Route path="contact" element={<Contact />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin/revenue" element={<AdminRevenueV2 />} />
          <Route path="bricoman" element={<Bricoman />} />
          <Route path="xero" element={<Xero />} />
          <Route path="xero/:url" element={<Xero />} />
          <Route path="customer/:id" element={<Customer />} />
          <Route path="createcreditnote" element={<CreateCreditNote />} />
          <Route path="createcreditnote/:id" element={<CreateCreditNote />} />
          <Route path="creditnote/:id" element={<CreditNoteDetail />} />
          <Route path="order/:id" element={<OrderDetail />} />
          <Route path="invoice/:id" element={<InvoiceDetail />} />
          <Route path="product/:id" element={<Product />} />
          <Route path="payment/:status" element={<Payment />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
